import { Dialog, DialogFooter, DialogType, IDialogContentProps, PrimaryButton, DefaultButton } from "@fluentui/react";
import { CircularProgress } from "@mui/material";

interface AlertConfirmationDialogProps {
  title?: string;
  subText?: any;
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isConfirmButtonDisabled?: boolean;
}

const AlertConfirmationDialog = ({
  title = "Create Alert",
  subText = "Are you sure you want to publish this alert?",
  isVisible,
  onConfirm,
  onCancel,
  isConfirmButtonDisabled,
}: AlertConfirmationDialogProps) => {
  const dialogContentProps: IDialogContentProps = {
    type: DialogType.normal,
    title,
    subText,
    styles: {
      title: {
        color: "white",
      },
      subText: {
        color: "#A19F9D",
      },
    },
  };

  return (
    <Dialog
      hidden={!isVisible}
      onDismiss={onCancel}
      dialogContentProps={dialogContentProps}
      modalProps={{
        isBlocking: true,
        styles: {
          main: { maxWidth: 450, backgroundColor: "#323130", color: "white" },
        },
      }}
    >
      <DialogFooter>
        <DefaultButton onClick={onCancel} text="Cancel" className="dialog__secondary--button" />
        <PrimaryButton onClick={onConfirm} disabled={isConfirmButtonDisabled} className="dialog__primary--button">
          {isConfirmButtonDisabled ? <CircularProgress size={20} /> : "Ok"}
        </PrimaryButton>
      </DialogFooter>
    </Dialog>
  );
};

export default AlertConfirmationDialog;
